import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiCall } from "services/api";

import { PermissionsEntities, PermissionsFilters } from "./types";

export const getAllPermissions = createAsyncThunk(
  "/auth/permissions",
  async (filters: PermissionsFilters, { rejectWithValue }) => {
    try {
      const response = await apiCall().get("/auth/permissions", {
        params: filters,
      });

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getUserPermissions = createAsyncThunk(
  "/auth/permissions/user",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall().get("/my/permissions");

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getUserPermissionByEntity = createAsyncThunk(
  "/auth/permissions/user/entity",
  async (
    values: {
      entityId: number;
      entityType: PermissionsEntities;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await apiCall().get(
        `/my/permissions/for/${values.entityType}/${values.entityId}`
      );

      return {
        data: response.data,
        id: values.entityId,
        type: values.entityType,
      };
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);
